export default (hash: { [x: string]: any }) =>
  Object.keys(hash || {}).map((key) => hash[key]);
